// client/src/components/Achievements/RankStep.jsx
import React from "react";

const RankStep = React.memo(function RankStep({ icon, label, sub, status, tone }) {
  let circleClass = "";
  let textClass = "";
  let subTextClass = "text-gray-400";

  if (status === "completed") {
    circleClass = tone?.completedCircle || "bg-indigo-600 text-white ring-4 ring-white shadow-sm";
    textClass = "text-gray-800";
  } else if (status === "current") {
    circleClass =
      tone?.currentCircle ||
      "bg-white border-2 border-indigo-500 text-indigo-600 ring-4 ring-indigo-100 shadow-md transform -translate-y-1 w-10 h-10 text-lg";
    textClass = tone?.currentText || "text-indigo-600";
    subTextClass = tone?.currentSubText || "text-indigo-400 font-bold";
  } else {
    circleClass = "bg-gray-200 text-gray-400 ring-4 ring-white";
    textClass = "text-gray-500";
  }

  return (
    <div className={`flex flex-col items-center ${status === "locked" ? "opacity-50" : ""}`}>
      <div
        className={`rounded-full flex items-center justify-center font-bold transition-all ${
          status === "current" ? "w-10 h-10 text-lg" : "w-8 h-8 text-xs"
        } ${circleClass}`}
      >
        <i className={`fa-solid ${icon}`}></i>
      </div>
      <p className={`text-[10px] font-bold mt-2 ${textClass}`}>{label}</p>
      <p className={`text-[9px] ${status === "current" ? subTextClass : "text-gray-400"}`}>
        {sub}
      </p>
    </div>
  );
});

export default RankStep;
